import Vue from 'vue';
import TicketsTable from './table';
import TicketsView from './view';

export default Vue.component('storm-tickets', {
  template: require('./template.html'),
  name: 'storm-tickets',
  components: {
    TicketsTable,
    TicketsView,
  },
  data() {
    return {
      view: 'table',
      activeTicket: null,
    };
  },
  methods: {
    setActiveTicket(ticket) {
      this.activeTicket = ticket;
      this.$router.push({ path: `/storm-tickets/view/${ticket._id}` });
    },
  },
});



// WEBPACK FOOTER //
// ./src/storm/pages/tickets/index.js